import { UserPermission } from "@cobliteam/common-types";

const UserAlertsPermission = {
  CONFIG_AND_VIEW_CUSTOM_ALERTS: UserPermission.CONFIG_AND_VIEW_CUSTOM_ALERTS,
};

export default UserAlertsPermission;
